import { useState, useEffect } from 'react';
import { useGetSubscriptionDetails } from '@app/data/Settings/useGetBillingAndPaymentsDetails';
import { BannerState } from '../types';

export const useBannerState = () => {
	const [bannerState, setBannerState] = useState<BannerState>({
		isVisible: false,
		type: null,
	});

	const { data: subscriptionDetails } = useGetSubscriptionDetails();

	useEffect(() => {
		if (subscriptionDetails) {
			// Check for cancellation banner
			const showCancellationBanner =
				subscriptionDetails?.status === 'scheduled_cancellation';

			const showPaymentFailureBanner =
				subscriptionDetails?.status === 'past_due';

			if (showPaymentFailureBanner) {
				setBannerState({ isVisible: true, type: 'payment_failure' });
			} else if (showCancellationBanner) {
				setBannerState({ isVisible: true, type: 'cancellation' });
			} else {
				setBannerState({ isVisible: false, type: null });
			}
		}
	}, [subscriptionDetails]);

	const setIsVisible = (visible: boolean) => {
		setBannerState((prev) => ({ ...prev, isVisible: visible }));
	};

	return {
		bannerState,
		setIsVisible,
	};
};
